import { useMemoizeArg } from "@r360/library";
import { useEffect } from "react";
import useTranslate from "./useTranslate";

// Extend the Window interface to include our custom properties
declare global {
    interface Window {
        r360?: {
            __TEXTS__?: Record<string, string>;
        };
        __TEXTS__?: Record<string, string>;
    }
}

/**
 * Hook that updates the texts object in window.r360 when texts change.
 * These texts are used by some r360 library components to set static aria-labels
 */
export const useWindowTexts = () => {
    const t = useTranslate();

    const texts = {
        close: t("book.general.close"),
        "see-more-images": t("book.see_more_images"),
        "enlarge-image": t("book.enlarge_image"),
        "delete-image": t("book.delete_image"),
        increment: t("book.general.add_one"),
        decrement: t("book.general.remove_one"),
        breadcrumbs: t("book.breadcrumbs"),
        "error-notification": t("book.error_notification"),
        "success-notification": t("book.success_notification"),
        "warning-notification": t("book.warning_notification"),
        "info-notification": t("book.info_notification"),
        "error-heading": t("book.error.heading"),
        "error-description": t("book.error.description"),
        "show-more": t("book.general.show_more"),
        reload: t("book.general.reload_page"),
        "to-startpage": t("book.general.to_startpage"),
    };

    useEffect(() => {
        if (!window.r360) {
            window.__TEXTS__ = texts;
        } else {
            window.r360.__TEXTS__ = texts;
        }
        // eslint-disable-next-line
    }, [useMemoizeArg(texts)]);
};
